import { DatabaseOutlined } from "@ant-design/icons";
import React from "react";
import { getPermissionsByRole } from "@/config/permission/permissions";
import { ERoutesPathname } from "@/routers/config";
import * as LazyComponents from "@/routers/lazyComponents";
import type { NavigationItem } from "@/routers/types";

/** The Charge Code V2 stock screens: delivery orders, stock, inventory adjustments and movements. Offered only while the UI speaks V2. */
export const CHARGE_CODE_V2_STOCK_NAVIGATION: NavigationItem = {
  key: "charge-code-v2",
  title: "Charge Code V2",
  path: ERoutesPathname.chargeCodeV2,
  icon: React.createElement(DatabaseOutlined),
  breadcrumb: "Charge Code V2",
  showInSidebar: true,
  order: 9,
  permissionRoles: getPermissionsByRole("inventory-nav"),
  children: [
    {
      key: "delivery-order-v2",
      title: "Delivery Order V2",
      path: ERoutesPathname.deliveryOrderV2,
      breadcrumb: "Delivery Order V2",
      component: LazyComponents.DeliveryOrderV2Page,
      permissionRoles: getPermissionsByRole("delivery-order-list"),
      children: [
        {
          key: "delivery-order-v2-create",
          title: "Create New",
          path: ERoutesPathname.deliveryOrderV2Create,
          breadcrumb: "Create New",
          pageTitle: "Create New Delivery Order",
          component: LazyComponents.DeliveryOrderV2FormPage,
          showInSidebar: false,
          permissionRoles: getPermissionsByRole("delivery-order-create"),
        },
        {
          key: "delivery-order-v2-edit",
          title: "Edit Delivery Order",
          path: ERoutesPathname.deliveryOrderV2Edit,
          breadcrumb: "Edit Delivery Order",
          pageTitle: (params) => `Edit ${params.name || "Delivery Order"}`,
          component: LazyComponents.DeliveryOrderV2FormPage,
          showInSidebar: false,
          permissionRoles: getPermissionsByRole("delivery-order-edit"),
        },
        {
          key: "delivery-order-v2-detail",
          title: "Delivery Order Detail",
          path: ERoutesPathname.deliveryOrderV2Detail,
          breadcrumb: "Delivery Order Detail",
          pageTitle: (params) => params.name || "Delivery Order Detail",
          component: LazyComponents.DeliveryOrderV2DetailPage,
          showInSidebar: false,
          permissionRoles: getPermissionsByRole("delivery-order-list"),
        },
      ],
    },
    {
      key: "inventory-v2",
      title: "Stock V2",
      path: ERoutesPathname.inventoryV2,
      breadcrumb: "Stock V2",
      component: LazyComponents.InventoryV2Page,
      permissionRoles: getPermissionsByRole("inventory-view"),
    },
    {
      key: "inventory-adjustment-v2",
      title: "Inventory Adjustment V2",
      path: ERoutesPathname.inventoryAdjustmentV2,
      breadcrumb: "Inventory Adjustment V2",
      component: LazyComponents.InventoryAdjustmentV2Page,
      permissionRoles: getPermissionsByRole("inventory-adjustment"),
      children: [
        {
          key: "inventory-adjustment-v2-create",
          title: "Create New",
          path: ERoutesPathname.inventoryAdjustmentV2Create,
          breadcrumb: "Create New",
          pageTitle: "Create New Adjustment",
          component: LazyComponents.InventoryAdjustmentV2FormPage,
          showInSidebar: false,
          permissionRoles: getPermissionsByRole("inventory-adjustment-create"),
        },
        {
          key: "inventory-adjustment-v2-edit",
          title: "Edit Adjustment",
          path: ERoutesPathname.inventoryAdjustmentV2Edit,
          breadcrumb: "Edit Adjustment",
          pageTitle: (params) => `Edit ${params.name || "Adjustment"}`,
          component: LazyComponents.InventoryAdjustmentV2FormPage,
          showInSidebar: false,
          permissionRoles: getPermissionsByRole("inventory-adjustment-create"),
        },
        {
          key: "inventory-adjustment-v2-detail",
          title: "Adjustment Detail",
          path: ERoutesPathname.inventoryAdjustmentV2Detail,
          breadcrumb: "Adjustment Detail",
          pageTitle: (params) => params.name || "Adjustment Detail",
          component: LazyComponents.InventoryAdjustmentV2DetailPage,
          showInSidebar: false,
          permissionRoles: getPermissionsByRole("inventory-adjustment-detail"),
        },
      ],
    },
    {
      key: "movement-v2",
      title: "Movement V2",
      path: ERoutesPathname.movementV2,
      breadcrumb: "Movement V2",
      component: LazyComponents.MovementV2Page,
      permissionRoles: getPermissionsByRole("delivery-order-list"),
    },
  ],
};
